import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import type { Seeds } from '#mailing/types';

import { Uri } from '#constants/uri';

/**
 * Retrieves the list of seed records for a specific mailing.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param mailingId - The unique identifier of the mailing to fetch seeds for.
 * @returns A promise that resolves to an `OperationResultWithData` containing an array of `Seeds`.
 * @throws Will throw an error if the HTTP request fails.
 */
export const getSeeds = async (instance: KyInstance, mailingId: number) => {
  try {
    return await instance
      .get<OperationResultWithData<Seeds[]>>(formatString(Uri.mailing.seeds, mailingId.toString()))
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
